import {
  JOBS_FETCH,
  JOB_FETCH_BY_ID,
  JOB_CREATE,
  JOB_UPDATE,
  JOB_SELECT,
} from '../actions';

const INIT_STATE = {
  list: [],
  current: null,
  selected: null,
};

export default function jobsReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case JOBS_FETCH.SUCCESS:
      return { ...state, list: action.payload };
    case JOB_FETCH_BY_ID.SUCCESS:
      return { ...state, current: action.payload };
    case JOB_CREATE.SUCCESS:
      return { ...state, list: [action.payload, ...state.list], selected: action.payload };
    case JOB_UPDATE.SUCCESS: {
      const updated = action.payload;
      return {
        ...state,
        list: state.list.map((j) => (j.job_id === updated.job_id ? updated : j)),
        selected: state.selected?.job_id === updated.job_id ? updated : state.selected,
      };
    }
    case JOB_SELECT.REQUEST: {
      const job = action.payload;
      return { ...state, selected: job?.job_id ? job : null };
    }
    default:
      return state;
  }
}
